import messages from './messages';

export const getLabel = (label: string) => {
  switch (label) {
    case 'requests':
      return messages.requests;
    case 'solutions':
      return messages.solutions;
    case 'confirmation':
      return messages.confirmation;

    case 'handling':
      return messages.handling;
    case 'issue':
      return messages.issue;
    case 'scanProducts':
      return messages.scanProducts;
    case 'summary':
      return messages.summary;

    case 'informations':
    default:
      return messages.informations;
  }
};
